// extracted by mini-css-extract-plugin
module.exports = {"overlay":"PlanModal_overlay__1M2Wq","inputContainer":"PlanModal_inputContainer__1iQUJ","text":"PlanModal_text__3DOfD","label":"PlanModal_label__1muq3"};